import { render, staticRenderFns } from "./ConfirmPasswordReset.vue?vue&type=template&id=b8d322a0&scoped=true"
import script from "./ConfirmPasswordReset.vue?vue&type=script&lang=ts"
export * from "./ConfirmPasswordReset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d322a0",
  null
  
)

export default component.exports